import { styled } from '@mui/material/styles';

const prefix = 'HusaSearch';
const classes = {
  searchIcon: `${prefix}-searchIcon`,
  input: `${prefix}-input`
};
const Search = styled('div')(({ theme }) => ({
  [`& .${classes.searchIcon}`]: {
    position: 'absolute',
    color: theme.palette.action.active,
    bottom: '22%',
    paddingLeft: theme.spacing(0.5),
    '& svg': {
      fontSize: '1.25rem'
    }
  },
  [`& .${classes.input}`]: {
    paddingLeft: theme.spacing(3)
  }
}));

export { classes, Search };
